/**
 * 支付方式标准配置（支付编码 / 支付方式 / 结算方式编码）
 */
export const PAY_METHOD_LIST = [
  { id: '7', name: '现金', proof: '0' },
  { id: '2', name: 'POS机', proof: '1' },
  { id: '3', name: '二维码收款', proof: '2' },
  { id: '6', name: '微信支付', proof: '2' },
  { id: '13', name: '支付宝支付', proof: '2' },
  { id: '4', name: '联通支付', proof: '3' },
  { id: '1', name: 'APP线上支付', proof: '10' },
  { id: '5', name: '退款转物业费', proof: '11' },
  { id: '8', name: '押金转水电费', proof: '12' },
  { id: '9', name: '押金转物业费', proof: '12' },
  { id: '10', name: '一卡通付', proof: '13' },
  { id: '14', name: '转账回款', proof: '3' },
  { id: '11', name: '银行支票', proof: '15' },
  { id: '12', name: '预交冲抵', proof: '16' },
  { id: '15', name: '饱和调整', proof: '9' },
  { id: '16', name: '被继承', proof: '9' },
  { id: '17', name: '地产结算', proof: '9' },
  { id: '18', name: '手动减免', proof: '9' },
  { id: '19', name: '物业减免', proof: '9' },
  { id: '20', name: '应收减免', proof: '9' },
  { id: '21', name: '折扣', proof: '9' }
]

/** 押金转换类支付方式 */
export const DEPOSIT_PAY_METHOD_IDS = ['8', '9']

export function getPayMethodName(id) {
  if (id === null || id === undefined || id === '') {
    return ''
  }
  const item = PAY_METHOD_LIST.find(p => String(p.id) === String(id))
  return item ? item.name : String(id)
}

export function getPayMethodProof(id) {
  if (id === null || id === undefined || id === '') {
    return ''
  }
  const item = PAY_METHOD_LIST.find(p => String(p.id) === String(id))
  return item ? item.proof : ''
}

export function isDepositPayMethod(id) {
  return DEPOSIT_PAY_METHOD_IDS.includes(String(id))
}
